import { INNER_STORE } from './constants'
import { get } from './inner-store'
import { iAuthData } from './types'

export type iGetAuthData = () => iAuthData

const getAuthData: iGetAuthData = () => get(INNER_STORE.auth)

export { getAuthData }
